import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  AppBar,
  Box,
  CssBaseline,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../assets/logo/black2.png";
import "../App.css";

// ✅ Import your search widget
import SearchWidget from "./Searchwidget";

const drawerWidth = 240;

const navItems = [
  { id: 1, name: "About Us", path: "#aboutus" },
  { id: 2, name: "Products", path: "#products" },
  { id: 3, name: "Partners", path: "#partners" },
  { id: 4, name: "Team", path: "#teams" },
  { id: 5, name: "Newsroom", path: "#newsroom" },
  { id: 6, name: "Contact Us", path: "#contactus" },
];

function Navbar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const isDesktop = useMediaQuery("(min-width:1024px)");

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "start" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#FFE6C9",
          p: "1rem",
        }}
      >
        <Typography variant="h6">Menu</Typography>
        <IconButton>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.id} disablePadding>
            <ListItemButton component="a" href={item.path}>
              <ListItemText primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <CssBaseline />
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* AppBar */}
        <AppBar
          component="nav"
          sx={{
            background: "#fff",
            height: "5rem",
            padding: { xs: "0 1rem", sm: "0 1rem", md: "0 5rem" },
          }}
        >
          <Toolbar
            sx={{
              height: "14vh",
              minHeight: "14vh",
              justifyContent: "space-between",
            }}
          >
            <a href="/">
              <Box
                width={{ xs: "10rem", sm: "11rem", md: "12rem" }}
                sx={{ flexGrow: 1 }}
              >
                <img src={logo} alt="Logo" width="100%" height="100%" />
              </Box>
            </a>

            {/* ✅ Desktop Widget */}
            {isDesktop && (
              <Box sx={{ ml: 2 }}>
                <SearchWidget />
              </Box>
            )}

            <Box sx={{ display: { xs: "none", lg: "flex" }, gap: "30px" }}>
              {navItems.map((item) => (
                <a
                  href={item.path}
                  key={item.id}
                  style={{
                    textDecoration: "none",
                    textTransform: "uppercase",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "0.9rem",
                      color: "#000",
                      textAlign: "center",
                    }}
                  >
                    {item.name}
                  </Typography>
                </a>
              ))}
            </Box>

            {/* Hamburger menu icon for mobile */}
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerToggle}
              sx={{ display: { lg: "none" } }}
            >
              <MenuIcon sx={{ color: "#000" }} />
            </IconButton>
          </Toolbar>
        </AppBar>

        {/* Drawer for mobile nav */}
        <Box component="nav">
          <Drawer
            anchor="right"
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: "block", lg: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>

        {/* ✅ Mobile Widget below navbar */}
        {!isDesktop && (
          <Box sx={{ mt: 10, px: 2 }}>
            <SearchWidget />
          </Box>
        )}
      </Box>
    </>
  );
}

Navbar.propTypes = {
  window: PropTypes.func,
};

export default Navbar;
